import { useCallback, useEffect, useMemo, useRef } from 'react';
import { Avatar, Badge, Flex, Typography } from 'antd';
import classNames from 'classnames';

import { useIntersectionObserver } from '@Hooks/useIntersectionObserver';
// import { ReactComponent as UserGroupIcon } from '@Icons/additional/user-group.svg';
import { ReactComponent as AvatarPlaceholder } from '@Icons/additional/avatar-user.svg';
import useResizeLayout from '@Hooks/useResizeLayout';

// import { MyTeamModal } from '../MyTeamModal';
import styles from './user-info.module.css';
import { getBadgeOffset, prepareStatus } from './utils';
import {
  USER_AVATAR_SIZE,
  USER_AVATAR_SIZE_MOBILE,
  OBSERVER_THRESHOLD_IN,
  OBSERVER_THRESHOLD_OUT,
} from './constants';

// interface MyTeamButtonProps {
//   isMobile: boolean;
//   onClick: () => void;
// }

// const MyTeamButton: React.FC<MyTeamButtonProps> = ({ isMobile, onClick }) => {
//   const buttonText = isMobile ? null : 'My Team';

//   return (
//     <Button
//       className={styles.myTeamButton}
//       type="default"
//       icon={<UserGroupIcon className="button-svg" />}
//       onClick={onClick}
//     >
//       {buttonText}
//     </Button>
//   );
// };

interface UserInfoProps {
  onStickyChange: (isSticky: boolean) => void;
  onHeightCalculated: (height: number) => void;
  name: string;
  occupation: string;
  photo: string | undefined;
  status: string | null;
}

// INFO: Hide my team modal by request from Ziad

const UserInfo: React.FC<UserInfoProps> = ({
  onStickyChange,
  onHeightCalculated,
  name,
  occupation,
  photo,
  status,
}) => {
  const { isMobile } = useResizeLayout();

  const avatarSize = isMobile ? USER_AVATAR_SIZE_MOBILE : USER_AVATAR_SIZE;

  // const [myTeamOpened, setMyTeamOpened] = useState(false);
  const badgeOffset = getBadgeOffset(avatarSize);
  const ref = useRef<HTMLDivElement>(null);

  const onIntersection = useCallback(
    (intersectionRatio: number) => {
      const isTabsSticky = intersectionRatio < OBSERVER_THRESHOLD_OUT;
      onStickyChange(isTabsSticky);
    },
    [onStickyChange]
  );
  const intersectionObserverConfig = useMemo(() => {
    return {
      threshold: [OBSERVER_THRESHOLD_IN, OBSERVER_THRESHOLD_OUT],
      rootSelector: '#profile-page',
      rootMargin: '0px',
      targetSelector: '#profile-page-user-header',
      onIntersection,
    };
  }, [onIntersection]);
  useIntersectionObserver(intersectionObserverConfig);

  useEffect(() => {
    const height = ref.current?.clientHeight as number;
    onHeightCalculated(height);
  }, [onHeightCalculated]);

  // const teamMemberMock = {
  //   avatar: <AvatarPlaceholder />,
  //   title: 'Ahmed Al Mansoori',
  //   occupation: 'Project Manager',
  // };

  // const teamMock = {
  //   manager: {
  //     avatar: <AvatarPlaceholder />,
  //     title: 'Fatima Bilani',
  //     occupation: 'Project Manager',
  //   },
  //   teamMembers: [
  //     teamMemberMock,
  //     teamMemberMock,
  //     teamMemberMock,
  //     teamMemberMock,
  //     teamMemberMock,
  //     teamMemberMock,
  //     teamMemberMock,
  //     teamMemberMock,
  //     teamMemberMock,
  //   ],
  // };

  const badgeStatus = prepareStatus(status);

  return (
    <Flex
      className={classNames(styles.wrapper, isMobile ? 'mobile' : null)}
      justify="space-between"
      align="center"
      ref={ref}
      id="profile-page-user-header"
    >
      <Flex align="center" gap={24}>
        <Badge
          dot
          status={badgeStatus}
          offset={badgeOffset}
          className={styles.status}
        >
          <Avatar
            className={styles.empAvatar}
            size={avatarSize}
            icon={<AvatarPlaceholder />}
            src={photo}
          />
        </Badge>
        <Flex vertical>
          <Typography.Text className={styles.name} strong>
            {name}
          </Typography.Text>
          <Typography.Text className={styles.occupation} type="secondary">
            {occupation}
          </Typography.Text>
        </Flex>
      </Flex>
      {/* <MyTeamButton onClick={() => setMyTeamOpened(true)} isMobile={isMobile} />
      <MyTeamModal
        content={teamMock}
        open={myTeamOpened}
        onCancel={() => setMyTeamOpened(false)}
      /> */}
    </Flex>
  );
};

export default UserInfo;
